// export const Logo = ({ dark = false }) => (
//   <a href="#top" data-testid="brand-logo" className="flex items-center gap-3" aria-label="Fouzia Tarannum — home">
//     <svg viewBox="0 0 48 48" className="h-10 w-10 shrink-0 drop-shadow-sm" aria-hidden="true">
//       <defs>
//         <linearGradient id="ftg" x1="0" y1="0" x2="1" y2="1">
//           <stop offset="0%" stopColor="#F69289" />
//           <stop offset="100%" stopColor="#D86258" />
//         </linearGradient>
//       </defs>
//       <circle cx="24" cy="24" r="22.5" fill="url(#ftg)" />
//       <path d="M24 3.5a20.5 20.5 0 0 1 0 41" fill="none" stroke="#FFFBF9" strokeOpacity="0.4" strokeWidth="1.2" />
//       <text x="24" y="30.5" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontStyle="italic" fontWeight="700" fontSize="18" fill="#FFFBF9">
//         FT
//       </text>
//     </svg>
//     <span className="leading-tight">
//       <span className={`block font-heading font-bold text-[15px] tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
//         Fouzia Tarannum
//       </span>
//       <span className={`block text-[9px] uppercase tracking-[0.28em] font-heading font-semibold ${dark ? "text-peach" : "text-peach-dark"}`}>
//         Guide &amp; Mentor
//       </span>
//     </span>
//   </a>
// );

// export const Logo = ({ dark = false }) => (
//   <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5" aria-label="Fouzia Tarannum — home">
//     <img
//       src="/logo.png"
//       alt="Fouzia Tarannum"
//       className="h-11 w-11 shrink-0 object-contain mix-blend-multiply scale-110"
//     />
//     <span className="leading-tight">
//       <span className={`block font-heading font-bold text-[15px] tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
//         Fouzia Tarannum
//       </span>
//       <span className={`block text-[9px] uppercase tracking-[0.28em] font-heading font-semibold ${dark ? "text-peach" : "text-peach-dark"}`}>
//         Guide &amp; Mentor
//       </span>
//     </span>
//   </a>
// );

export const Logo = ({ dark = false }) => (
  <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5" aria-label="Fouzia Tarannum — home">
    <img
      src="/logo.png"
      alt="Fouzia Tarannum"
      className="h-11 w-11 shrink-0 object-contain mix-blend-multiply scale-110"
    />
    <span className="leading-tight">
      <span className={`block font-heading font-bold text-[15px] tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
        Fouzia Tarannum
      </span>
      <span className={`block text-[9px] uppercase tracking-[0.28em] font-heading font-semibold ${dark ? "text-peach" : "text-peach-dark"}`}>
        Guide &amp; Mentor
      </span>
    </span>
  </a>
);
